import { FormLike, ToastyLike } from '@/ui/types/components.types';
import useI18n from '@/ui/composables/base/use-i18n';
import serviceProvider from '@/services/service-provider';
import { ObjectLike } from '@/types/objectlike.types';

const MODULE = 'Login';

export default function (vm: any, $refs: any, loginVariables: ObjectLike) {
  const {
    username,
    password,
    loading,
    errorMessage,
  } = loginVariables;

  const store = vm.$store;

  function handleError(error: any) {
    const { getText } = useI18n(vm);

    const toasty = $refs.toasty as Vue & ToastyLike;
    const SUBMODULE = 'errors';
    const DEFAULT_ERROR = 'general';

    errorMessage.value = getText(MODULE, SUBMODULE, DEFAULT_ERROR);

    if (error.message === 'user_does_not_exists') {
      errorMessage.value = getText(MODULE, SUBMODULE, 'invalidUsernameOrPassword');
    } else if (error.message === 'user_email_verification') {
      errorMessage.value = getText(MODULE, SUBMODULE, 'emailVerification');
    }
    toasty.show();
  }

  async function submit() {
    if (!vm) return;

    loading.value = true;

    // This is a hack to let typescript know that child has validate method
    const form = $refs.form as Vue & FormLike;
    form.validate();

    const { valid } = form;

    if (!valid) {
      loading.value = false;
      return;
    }

    try {
      const user = await serviceProvider.auth.login(username.value, password.value);
      store.dispatch('user/mountUser', user);

      vm.$router.replace({ name: 'Home' });
    } catch (error) {
      console.error(error);
      handleError(error);
    } finally {
      loading.value = false;
    }
  }

  function goToLandingPage() {
    vm.$router.replace({ name: 'LandingPage' });
  }

  return { submit, goToLandingPage };
}
